
const handlers = {
    openModal: () => {}
}

export default handlers;